import React from 'react';
import './../index.css';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function PhotoGear() {

  const gears = ['Canon 200D', 'Samsung Galaxy S21 Ultra', 'GoPro Hero 8']

  return (
    <div>
      <Stack className='gears-div' direction="row" spacing={1}>
        {
          gears.map((gear) => (
            <Chip color="primary" label={gear} variant="outlined" />
          ))
        }
      </Stack>
    </div>
  )
}